import React, { useEffect, useState } from "react";
import FlipCell from "./FlipCell";
import "../styles/Board2.css";

/**
 * LiveClock - displays HH:MM:SS using FlipCell, updating every second.
 * Each digit flips only when it changes (because FlipChar compares previous char).
 */
const LiveClock = ({ showSeconds = true }) => {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  const format = (d) => {
    const hh = String(d.getHours()).padStart(2, "0");
    const mm = String(d.getMinutes()).padStart(2, "0");
    const ss = String(d.getSeconds()).padStart(2, "0");
    return showSeconds ? `${hh}:${mm}:${ss}` : `${hh}:${mm}`;
  };

  return (
    <div className="live-clock" aria-live="polite">
      <FlipCell value={format(now)} width={8} />
    </div>
  );
};

export default LiveClock;
